import React, { useState } from "react";

import Button from "@/components/UI/Button";

import TimeSlotPicker from "./TimeSlotPicker";
import WorkflowHeader from "./WorkflowHeader";

const ScheduleIntakeConsultation = ({
  addToInAppHistory,
  alreadyScheduled,
  appToDisplay,
  consultationToConfirm,
  goBackInAppHistory,
  schedulingData,
  setAlreadyScheduled,
  setAppToDisplay,
  setConsultationToConfirm,
  setSchedulingData,
  setWithinAppHistory,
  withinAppHistory,
  workflowInstance,
}) => {
  const [dayIndex, setDayIndex] = useState(0);
  const [selectedAppointment, setSelectedAppointment] = useState(consultationToConfirm);

  return (
    <>
      <WorkflowHeader header="Schedule your care consultation" showImage={true} />
      <TimeSlotPicker
        dayIndex={dayIndex}
        schedulingData={schedulingData}
        selectedAppointment={selectedAppointment}
        setAppToDisplay={setAppToDisplay}
        setConsultationToConfirm={setConsultationToConfirm}
        setDayIndex={setDayIndex}
        setSchedulingData={setSchedulingData}
        setSelectedAppointment={setSelectedAppointment}
        workflowInstance={workflowInstance}
      />

      <div className="workflow-container-sm d-flex justify-content-between">
        <Button
          className="Btn Btn--otl-gry Btn--sm-2 workflow-btn"
          onClick={() => {
            goBackInAppHistory(withinAppHistory, setWithinAppHistory);
          }}
          type="button"
        >
          Back
        </Button>
        <Button
          className="Btn Btn--pri Btn--sm-2 workflow-btn"
          disabled={!selectedAppointment}
          onClick={() => {
            setConsultationToConfirm(selectedAppointment);
            addToInAppHistory(
              appToDisplay,
              setAppToDisplay,
              alreadyScheduled,
              setAlreadyScheduled,
              selectedAppointment,
              setConsultationToConfirm,
              withinAppHistory,
              setWithinAppHistory,
            );

            setSelectedAppointment(null);
            setAppToDisplay("confirmConsultation");
          }}
          type="button"
        >
          Continue
        </Button>
      </div>
    </>
  );
};

export default ScheduleIntakeConsultation;
